import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstampService {

  constructor(private http: HttpClient) { }

  apiUrl: string = environment.apiUrl;


  getInventoryList(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(this.apiUrl + `/bulk-estamp/admin/scanned-stamps`, { params }).pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.meta.total
      }))
    )
  }

  getClientOrders(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(this.apiUrl + `/bulk-estamp/admin/stamp-requests`, { params }).pipe(
      map((res: any) => ({
        ...res,
        totalCount: res.meta.total
      }))
    )
  }

  generateBulkInvoice(id: string) {
    return this.http.post<any>(
      this.apiUrl + `/bulk-estamp/admin/stamp-request/${id}/generate-invoice`,
      {}
    );
  }

  orderProcess(id: string, reason: string) {
    return this.http.post<any>(
      this.apiUrl + `/bulk-estamp/admin/stamp-request/${id}/process-order`,
      { reason }
    );
  }

  rejectPayment(id: string, reason: string) {
    return this.http.post<any>(
      this.apiUrl + `/bulk-estamp/admin/stamp-request/${id}/reject-payment`,
      { reason }
    );
  }
}
